import {stringify} from 'query-string';
import {get} from 'svelte/store';
import {PATHS} from '@/const/paths';
import {fixLink$} from '@/store/lang';
import type {SERVICE_DIRECTIONS} from '@/modules/fiat/utils/service';

function getUrlParams() {
  const search = decodeURIComponent(window.location.search);
  return new URLSearchParams(search);
}

/**
 * buy方向支持的链接参数
 */
export const SUPPORT_URL_PARAMS = ['fiat', 'currency', 'fiatAmount', 'digitalAmount', 'method', 'cardId', 'id', 'sub', 'bindNewCard', 'paymentMethod'] as const;

/**
 * buy方向：获取链接支持的所有参数
 */
export function getOneClickSupportUrlParams(cleanAction?: (params: {key: string; value: any}) => Boolean) {
  if (typeof window === 'undefined') {
    return {};
  }
  const urlParams = getUrlParams();
  const formatedParams = SUPPORT_URL_PARAMS.reduce((previousData, param) => {
    const value = urlParams.get(param);

    if (cleanAction && cleanAction({key: param, value})) {
      return previousData;
    }

    previousData[param] = urlParams.get(param);
    return previousData;
  }, {} as ONE_CLICK_BUY_URL_PARAMS);
  /** fiatAmount和digitalAmount只能同时出现一个 */
  if (formatedParams.fiatAmount && formatedParams.digitalAmount) {
    delete formatedParams.digitalAmount;
  }
  return formatedParams;
}

export function defineOneClickUrlParams(params: ONE_CLICK_BUY_URL_PARAMS | {side: SERVICE_DIRECTIONS}) {
  return params;
}

export type ONE_CLICK_BUY_URL_PARAMS = Partial<Record<typeof SUPPORT_URL_PARAMS[number], any>>;

export function gotoOneClickPlaceOrderPage(params?: ONE_CLICK_BUY_URL_PARAMS | {side: 'buy' | 'sell'}, options?: {replaceURL: boolean}) {
  const searchParams = params ? `?${stringify(params)}` : '';
  const action = options?.replaceURL ? 'replace' : 'assign';
  const fixLink = get(fixLink$);
  const url = `${fixLink(PATHS.FIAT_BUY_CRYPTO_PLACE_ORDER.pathname)}${searchParams}`;
  window.location[action](url);
}

/**
 * buy方向：跳转到选择支付方式页面
 */
export function gotoBuySelectPaymentMethodPage(params: ONE_CLICK_BUY_URL_PARAMS) {
  const fixLink = get(fixLink$);
  const url = `${fixLink(PATHS.FIAT_BUY_CRYPTO_BUY_PAYMENT_METHOD.pathname)}?${stringify(params)}`;
  window.location.assign(url);
}

/** buy方向：跳转到确认订单页 */
export function gotoOneClickBuyConfirmPage(params: ONE_CLICK_BUY_URL_PARAMS, options?: {replaceURL: boolean}) {
  const fixLink = get(fixLink$);
  const action = options?.replaceURL ? 'replace' : 'assign';
  const url = `${fixLink(PATHS.FIAT_BUY_CRYPTO_BUY_CONFIRM.pathname)}?${stringify(params)}`;
  window.location[action](url);
}

/**
 * sell方向：跳转到选择支付方式页面
 */
export function gotoSellSelectPaymentMethodPage(params: ONE_CLICK_BUY_URL_PARAMS) {
  const fixLink = get(fixLink$);
  const url = `${fixLink(PATHS.FIAT_BUY_CRYPTO_SELL_PAYMENT_METHOD.pathname)}?${stringify(params)}`;
  window.location.assign(url);
}

/** sell方向：跳转到确认订单页 */
export function gotoOneClickSellConfirmPage(params: ONE_CLICK_BUY_URL_PARAMS) {
  const fixLink = get(fixLink$);
  const url = `${fixLink(PATHS.FIAT_BUY_CRYPTO_SELL_CONFIRM.pathname)}?${stringify(params)}`;
  window.location.assign(url);
}
